import { z } from 'zod';

/**
 * The new sign-in email, as typed in Settings → Security. Trimmed and
 * lowercased before it is checked, the way Clerk compares addresses; the
 * message is an i18n key. Whether it is the CURRENT address is the form's
 * question (it knows the account), not the schema's.
 */
export const changeEmailSchema = z.object({
  email: z.string().trim().toLowerCase().pipe(z.email('validation.email.invalid')),
});

export type ChangeEmailInput = z.infer<typeof changeEmailSchema>;
